module.exports = __webpack_public_path__ + "static/media/kitties.10455981.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/partners/kitties.png
// module id = 411
// module chunks = 0